export { default as SenderDocument } from './SenderDocument'
export { default as SendersEndpoint } from './SendersEndpoint'
export { default as PrivateChatsEndpoint } from '../PrivateChatsEndpoint'